<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      d="M4 4L44 44M44 4L4 44"
    />
  </svg>
</template>
